import { Component, input, OnInit, output, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { AnchorType } from '../../../../../models';

@Component({
    selector: 'anchor-type',
    templateUrl: './anchor-type.component.html',
    styleUrls: ['./anchor-type.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [FormsModule, MatButtonToggleModule]
})
export class AnchorTypeComponent implements OnInit {
  anchorTypeList = input<AnchorType[]>([]);
  selectedAnchorType?: AnchorType;

  onSelectedAnchorType = output<AnchorType>();

  constructor() { }

  ngOnInit(): void {
    if (this.anchorTypeList()) {
      // set the first element as default
      this.selectedAnchorType = this.anchorTypeList()[0];
      this.selectAnchorType(this.selectedAnchorType);
    }
  }

  selectAnchorType(e: AnchorType) {
    this.onSelectedAnchorType.emit(e);
  }

}
